/**
 * Custom Age Verification
 * Sin dependencias de apps externas
 */

(function () {
    'use strict';

    const AGE_VERIFY_KEY = 'age_verified';
    const AGE_VERIFY_EXPIRY = 'age_verify_expiry';
    const DAYS_TO_REMEMBER = 30; // Días que recordar la verificación

    // Configuración (editable desde el Shopify admin)
    const config = {
        title: 'Verificación de Edad',
        subtitle: '¿Eres mayor de 18 años?',
        yesText: 'Sí',
        noText: 'No',
        rejectedMessage: 'Lo sentimos, debes ser mayor de 18 años para acceder a este sitio.',
        redirectUrl: 'https://www.google.com' // URL a redirigir si dicen "No"
    };

    // Función para verificar si ya está verificado y no ha expirado
    function isAlreadyVerified() {
        const verified = localStorage.getItem(AGE_VERIFY_KEY);
        const expiry = localStorage.getItem(AGE_VERIFY_EXPIRY);

        if (verified === 'true' && expiry) {
            const expiryDate = parseInt(expiry);
            const now = Date.now();

            if (now < expiryDate) {
                return true;
            } else {
                // Expiró, limpiar
                localStorage.removeItem(AGE_VERIFY_KEY);
                localStorage.removeItem(AGE_VERIFY_EXPIRY);
            }
        }

        return false;
    }

    // Función para guardar la verificación
    function saveVerification() {
        const expiryDate = Date.now() + (DAYS_TO_REMEMBER * 24 * 60 * 60 * 1000);
        localStorage.setItem(AGE_VERIFY_KEY, 'true');
        localStorage.setItem(AGE_VERIFY_EXPIRY, expiryDate.toString());
    }

    // Función para crear el popup
    function createPopup() {
        const overlay = document.createElement('div');
        overlay.className = 'age-verify-overlay';
        overlay.id = 'ageVerifyOverlay';

        overlay.innerHTML = `
      <div class="age-verify-modal">
        ${config.logoUrl ? `<div class="age-verify-logo"><img src="${config.logoUrl}" alt="Logo"></div>` : ''}
        <h2 class="age-verify-title">${config.title}</h2>
        <p class="age-verify-subtitle">${config.subtitle}</p>
        <div class="age-verify-buttons">
          <button class="age-verify-btn age-verify-btn-yes" data-verify="yes">
            ${config.yesText}
          </button>
          <button class="age-verify-btn age-verify-btn-no" data-verify="no">
            ${config.noText}
          </button>
        </div>
        <div class="age-verify-rejected" id="ageVerifyRejected">
          ${config.rejectedMessage}
        </div>
      </div>
    `;

        document.body.appendChild(overlay);
        document.body.classList.add('age-verify-active');

        // Event listeners
        const yesBtn = overlay.querySelector('[data-verify="yes"]');
        const noBtn = overlay.querySelector('[data-verify="no"]');

        yesBtn.addEventListener('click', handleYes);
        noBtn.addEventListener('click', handleNo);
    }

    // Handler para botón "Sí"
    function handleYes() {
        saveVerification();
        hidePopup();
    }

    // Handler para botón "No"
    function handleNo() {
        const rejectedMsg = document.getElementById('ageVerifyRejected');
        if (rejectedMsg) {
            rejectedMsg.classList.add('show');
        }

        // Redirigir después de 2 segundos
        setTimeout(function () {
            window.location.href = config.redirectUrl;
        }, 2000);
    }

    // Función para ocultar el popup
    function hidePopup() {
        const overlay = document.getElementById('ageVerifyOverlay');
        if (overlay) {
            overlay.classList.add('hide');
            document.body.classList.remove('age-verify-active');

            setTimeout(function () {
                overlay.remove();
            }, 300);
        }
    }

    // Inicializar
    function init() {
        // No mostrar si ya está verificado
        if (isAlreadyVerified()) {
            console.log('[Age Verify] Ya verificado previamente');
            return;
        }

        console.log('[Age Verify] Mostrando popup de verificación');
        createPopup();
    }

    // Ejecutar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
